import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function ObjectAgentRequirements() {
    return (
        <React.Fragment>
            <p>
                Flight Gateway integrates with Manager+Agents version 13.5 or higher allowing you to use Object Mover to
                transfer data to object storage. For more information, see the{' '}
                <a href="/flight/gateway/general/integrating-manager-agents">Flight Gateway integration guide</a>
            </p>
            <p>
                Flight Gateway supports the following storage platforms:
                <ul>
                    <li>Amazon AWS S3</li>
                    <li>Microsoft Azure Blob</li>
                    <li>Google Cloud Storage</li>
                </ul>
            </p>
            <p>Object Mover is supported on the following Agent platforms:</p>
            <ul>
                <li>Apple macOS 10.14</li>
                <li>CentOS Linux 7</li>
                <li>CentOS Linux 8</li>
                <li>Red Hat Enterprise Linux 7</li>
                <li>Red Hat Enterprise Linux 8</li>
                <li>Microsoft Windows Server 2016</li>
                <li>Microsoft Windows Server 2019</li>
            </ul>
            <p>
                <strong>Note</strong>: Object Mover for Windows, CentOS 8, and Red Hat Enterprise Linux 8 requires{' '}
                <strong>Manager+Agents version 15.0</strong> or higher.
            </p>
        </React.Fragment>
    );
}

ObjectAgentRequirements.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ObjectAgentRequirements);
